import { render } from "./SocialMedia.vue?vue&type=template&id=f5f349a4"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__